import { createSlice } from '@reduxjs/toolkit';
import { IReduxState } from '../../interfaces/IReduxState';

export const DeleteSpaceTypesSlice = createSlice({
  name: 'DeleteSpaceTypes',
  initialState: { isLoading: false, data: {} } as IReduxState,
  reducers: {
    deleteSpaceTypes: (state, _) => {
      state.isLoading = true;
    },
    successDeleteSpaceTypes: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    failureDeleteSpaceTypes: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    clearDeleteSpaceTypes: (state) => {
      state.data = {};
    },
  },
});

export const {
  deleteSpaceTypes,
  failureDeleteSpaceTypes,
  successDeleteSpaceTypes,
  clearDeleteSpaceTypes,
} = DeleteSpaceTypesSlice.actions;

export default DeleteSpaceTypesSlice.reducer;
